var map = {
	"./de.json": [
		4299,
		299
	],
	"./en.json": [
		3683,
		683
	],
	"./wsw/de.json": [
		35,
		35
	],
	"./wsw/en.json": [
		139,
		139
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2557;
module.exports = webpackAsyncContext;